interface FeatureItem {
  icon: string;
  title: string;
  description: string;
}

const features: FeatureItem[] = [
  {
    icon: 'ri-smartphone-line',
    title: '多端适配 · 流畅阅读',
    description: '支持手机、平板、电脑全端访问，下拉式阅读体验丝滑流畅。无论通勤路上还是居家放松，随时随地打开浏览器就能畅享漫画乐趣，无需下载安装任何应用。',
  },
  {
    icon: 'ri-timer-flash-line',
    title: '每日更新 · 同步连载',
    description: '站内漫画资源每日同步更新，热门连载作品第一时间追踪。再也不用担心错过最新话，女神漫画帮你时刻保持与全球漫画读者的同步节奏。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '纯净阅读 · 无广告干扰',
    description: '坚持免费纯净的阅读理念，全程无弹窗广告和强制跳转。高清画质搭配沉浸式阅读界面，让你专注于漫画本身，享受最纯粹的二次元时光。',
  },
];

export default function Features() {
  return (
    <section id="features" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-2">
          平台优势
        </h2>
        <p className="text-sm text-foreground-600 text-center mb-8 md:mb-10">
          为什么选择女神漫画？
        </p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 max-w-5xl mx-auto">
          {features.map((feature, idx) => (
            <div
              key={idx}
              className="text-center p-6 md:p-8 rounded-lg bg-background-50 border border-background-200 hover:border-secondary-200 transition-all duration-200"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 mx-auto mb-4 rounded-full bg-secondary-100 flex items-center justify-center">
                <span className="w-7 h-7 md:w-8 md:h-8 flex items-center justify-center text-secondary-600">
                  <i className={`${feature.icon} text-2xl md:text-3xl`}></i>
                </span>
              </div>
              <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-3">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}